import { Wifi, Monitor, Smartphone, ShieldCheck, Headphones, Tv, Clock } from "lucide-react";

const features = [
  {
    icon: Wifi,
    title: "Tecnologia P2P",
    desc: "Sistema peer-to-peer distribuído que elimina travamentos e garante transmissão estável, mesmo em horários de pico.",
    span: "md:col-span-2",
  },
  {
    icon: Monitor,
    title: "Qualidade HD/4K",
    desc: "Transmissão em alta definição com suporte a 4K, garantindo a melhor qualidade de imagem.",
    span: "",
  },
  {
    icon: Clock,
    title: "Gravação de 5 Dias",
    desc: "Não perca nada! Nosso app grava automaticamente o conteúdo ao vivo por 5 dias. Assista o que passou ontem ou nos últimos dias.",
    span: "",
  },
  {
    icon: Tv,
    title: "Todos os Canais",
    desc: "Esportes, filmes, séries, documentários, infantil e muito mais, sempre atualizado.",
    span: "",
  },
  {
    icon: Smartphone,
    title: "Multiplataforma",
    desc: "Funciona em Smart TV, celular, tablet, PC e TV Box. Use em 1 dispositivo por vez e alterne quando quiser.",
    span: "",
  },
  {
    icon: ShieldCheck,
    title: "100% Estável e Seguro",
    desc: "Servidores redundantes garantindo disponibilidade 24/7 sem quedas. Serviço confiável avaliado em 4.8 estrelas.",
    span: "md:col-span-2",
  },
  {
    icon: Headphones,
    title: "Suporte 24/7",
    desc: "Equipe especializada disponível todos os dias para ajudar na instalação pelo WhatsApp.",
    span: "",
  },
];

export const Features = () => (
  <section id="beneficios" data-testid="features-section" className="py-24 px-4 sm:px-6">
    <div className="max-w-6xl mx-auto">
      <div className="mb-14 max-w-2xl">
        <p className="text-[#FF5A00] text-sm font-bold uppercase tracking-[0.25em] mb-3">Por que New Braz?</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter" style={{ fontFamily: "Outfit, sans-serif" }}>
          Tudo que você precisa em um só lugar
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        {features.map((f, i) => (
          <div
            key={i}
            data-testid={`feature-card-${i}`}
            className={`bg-[#0F0F13] border border-white/10 rounded-2xl p-8 hover:-translate-y-1 hover:border-[#FF5A00]/40 transition-all duration-300 ${f.span}`}
          >
            <div className="w-12 h-12 rounded-xl bg-[#FF5A00]/10 border border-[#FF5A00]/20 flex items-center justify-center mb-5">
              <f.icon className="w-6 h-6 text-[#FF5A00]" />
            </div>
            <h3 className="text-lg font-bold mb-2" style={{ fontFamily: "Outfit, sans-serif" }}>{f.title}</h3>
            <p className="text-sm text-white/55 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
